export default __webpack_public_path__ + "static/media/ProfilePic.e2078d2e.jpg";